<template>
  <div>Não possui filtro</div>
</template>

<script>
  export default {
    props: {
      module: {
        type: Object,
        required: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Api.vue?555f6642